
import {
	Component, Vue, Prop,
} from 'vue-property-decorator';

const TEST_ID = 'Kloans-IconChip';

@Component
export default class IconChip extends Vue {
	@Prop()
	public contentClass!: string;

	@Prop({ default: TEST_ID })
	public dataTestid!: string;

	@Prop({ type: String })
	public icon!: string;

	@Prop()
	public id!: string;

	@Prop({ default: '100' })
	public sizeInPx!: string;

	@Prop({ default: true })
	public withContent!: boolean;
}
